module.exports = __webpack_public_path__ + "img/__icon_TANDEM ZESTAW.011b3a82.svg";